import { type PayoutTraderConfig } from '~/entities/payout';
import { type AcceptRateLimitMode } from '../../model';

export const getAcceptRateLimitMode = (config?: PayoutTraderConfig): AcceptRateLimitMode => {
    const acceptRateLimit = config?.acceptRateLimit;

    if (!acceptRateLimit) {
        return 'default';
    }

    return Number(acceptRateLimit.maxAccepts) > 0 ? 'custom' : 'unlimited';
};
